import { useNavigate } from 'react-router-dom';
import Url from '../../data/url';
import { useTranslation } from '../../hook/useTranslation';

function Informations() {
  const navigate = useNavigate();
  const { t, locale, changeLanguage } = useTranslation();

  return (
    <div className="w-full my-[24px] pb-15">
      <div className="w-full flex items-start flex-col justify-start gap-[12px] mb-10">
        <div className="flex items-center justify-start text-left font-[700] text-[14px]">
          {t('my.community')}
        </div>
        <button
          type="button"
          onClick={() => navigate(Url.Community)}
          className="text-left font-[400] text-[14px] mb-5"
        >
          {t('my.notice')}
        </button>
        <div className="flex items-center justify-start text-left font-[700] text-[14px]">
          {t('my.service_info')}
        </div>
        <button
          type="button"
          onClick={() => navigate(Url.MyFrequentQnA)}
          className="text-left font-[400] text-[14px]"
        >
          {t('my.faq')}
        </button>
        <button
          type="button"
          onClick={() => navigate(Url.MyPrivateQnA)}
          className="text-left font-[400] text-[14px]"
        >
          {t('my.qna')}
        </button>
        <button
          type="button"
          onClick={() => navigate(Url.MyList)}
          className="text-left font-[400] text-[14px]"
        >
          {t('my.my_posts')}
        </button>
      </div>
      <div className="w-full flex items-start flex-col justify-start gap-[12px] mb-10">
        <div className="flex items-center justify-start text-left font-[700] text-[14px]">
          {t('my.usage_guide')}
        </div>
        <button
          type="button"
          onClick={() => navigate(Url.MyUsageGuide)}
          className="text-left font-[400] text-[14px]"
        >
          {t('my.privacy')}
        </button>
        <button
          type="button"
          onClick={() => navigate(Url.MyCompanyInfo)}
          className="text-left font-[400] text-[14px]"
        >
          {t('my.company_info')}
        </button>
      </div>
      {import.meta.env.DEV && (
        <div className="w-full flex items-start flex-col justify-start gap-[12px]">
          <div className="flex items-center justify-start text-left font-[700] text-[14px]">
            {t('my.language_settings')}
          </div>
          <button
            type="button"
            onClick={() => changeLanguage(locale === 'ko' ? 'en' : 'ko')}
            className="text-left font-[400] text-[14px]"
          >
            {t('my.change_language')}
          </button>
        </div>
      )}
    </div>
  );
}

export default Informations;
